import React from 'react';

export default function StepFetching({ steps }) {
  // steps: [{ label, status }] status: 'pending' | 'active' | 'done' | 'error'
  return (
    <div>
      <div className="page-header">
        <div className="page-title">Fetching data</div>
        <div className="page-sub">Retrieving search volumes and current client rankings from DataForSEO. This may take a minute.</div>
      </div>

      <div className="card">
        {steps.map((step, i) => (
          <div
            key={i}
            className={`fetch-step ${step.status === 'done' ? 'done' : ''} ${step.status === 'active' ? 'active' : ''}`}
          >
            {step.status === 'done' && (
              <div className="fetch-check">✓</div>
            )}
            {step.status === 'active' && <span className="spinner" />}
            {step.status === 'pending' && (
              <div style={{ width: 16, height: 16, borderRadius: '50%', border: '1.5px solid var(--gray-300)', flexShrink: 0 }} />
            )}
            {step.status === 'error' && (
              <div style={{ width: 16, height: 16, borderRadius: '50%', background: 'var(--red-light)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 10, color: 'var(--red)', flexShrink: 0 }}>✕</div>
            )}
            {step.label}
          </div>
        ))}
      </div>
    </div>
  );
}
